var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCultry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1962_58642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 58C45.464 58 58 45.464 58 30C58 14.536 45.464 2 30 2C14.536 2 2 14.536 2 30C2 45.464 14.536 58 30 58Z",
    fill: "#556A2A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1962_58642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0061 23.3298C37.0061 21.0943 35.7162 17.7144 33.7765 17.7144C31.8368 17.7144 30.5469 21.0943 30.5469 23.3298C30.5469 25.5653 31.7204 27.2868 33.2479 27.6311L32.4478 42.6154C32.4478 42.6639 32.4478 42.7124 32.4478 42.756C32.4866 43.4883 33.1121 44.0508 33.8444 44.012C34.5766 43.9732 35.1391 43.3476 35.1003 42.6154L34.3002 27.6311C35.8326 27.2917 37.0013 25.4926 37.0013 23.3298H37.0061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5199 17.3413C27.3163 17.3413 27.1514 17.5062 27.1514 17.7098V23.8054C27.1514 23.9508 27.0301 24.0721 26.8847 24.0721C26.7392 24.0721 26.618 23.9508 26.618 23.8054V17.7098C26.618 17.5062 26.4531 17.3413 26.2494 17.3413C26.0457 17.3413 25.8809 17.5062 25.8809 17.7098V23.8054C25.8809 23.9508 25.7596 24.0721 25.6142 24.0721C25.4687 24.0721 25.3474 23.9508 25.3474 23.8054V17.7098C25.3474 17.5062 25.1826 17.3413 24.9789 17.3413C24.7752 17.3413 24.6104 17.5062 24.6104 17.7098V23.8054C24.6104 23.9508 24.4891 24.0721 24.3436 24.0721C24.1982 24.0721 24.0769 23.9508 24.0769 23.8054V17.7098C24.0769 17.5062 23.9121 17.3413 23.7084 17.3413C23.5047 17.3413 23.3398 17.5062 23.3398 17.7098V24.8092C23.3398 26.167 24.0866 27.3065 25.0904 27.6072L24.2806 42.6109C24.2806 42.6594 24.2806 42.7079 24.2806 42.7515C24.3194 43.4837 24.945 44.0463 25.682 44.0075C26.4143 43.9687 26.9768 43.3431 26.938 42.606L26.1282 27.6024C27.1271 27.3017 27.8788 26.1621 27.8788 24.8043V17.705C27.8788 17.5013 27.7139 17.3364 27.5102 17.3364L27.5199 17.3413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3425 50.2685C41.3476 50.2685 50.269 41.3471 50.269 30.342C50.269 19.3369 41.3476 10.4155 30.3425 10.4155C19.3374 10.4155 10.416 19.3369 10.416 30.342C10.416 41.3471 19.3374 50.2685 30.3425 50.2685Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1962_58642",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1962_58642"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1962_58642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.6836,
    height: 40.6836,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCultry);
export default __webpack_public_path__ + "static/media/cultry.6347a6161fa35a9fdfea2fb9899de073.svg";
export { ForwardRef as ReactComponent };